export default __webpack_public_path__ + "static/MittagstischDark-cd4e07060029dcf4d7ed560bfbd50123.png";